// @ts-nocheck
import {
  Button,
  Paper,
  TextField,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
} from "@material-ui/core";
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import * as React from "react";
import { useForm } from "react-hook-form";

type NetworkState = "PENDING" | "SUCCEED" | "FAILED" | "IDLE";

// utils/validators.js
export const validateIranMobile = (value: string): boolean | string => {
  const regex = /^09\d{9}$/;
  if (value) {
    if (!regex.test(value)) {
      return "شماره موبایل صحیح نمیباشد";
    }
    return true;
  }
};

interface ResovledData {
  salesCount: string;
  totalSalesAmount: string;
  totalSellerPaymentsAmount: string;
}

interface IFormInput {
  sellerMobile: string;
}

export function ShowSellerInfo() {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<IFormInput>({
    mode: "onChange",
    defaultValues: {
      sellerMobile: null,
    },
  });

  const [errorMessages, setErrorMessages] = React.useState([]);
  const [networkState, setNetworkState] = React.useState<NetworkState>("IDLE");
  const [financialInfo, setFinancialInfo] = React.useState<ResovledData>({
    salesCount: null,
    totalSalesAmount: null,
    totalSellerPaymentsAmount: null,
  });

  const ERROR_MESSAGES_TRANSLATE = {
    "user-with-this-mobile-not-found": "کاربری با شماره وارد شده یافت نشد!",
  };

  const onSubmit = async (data: IFormInput) => {
    console.log("🚀 ~ file: ShowSellerInfo.tsx:64 ~ onSubmit ~ data:", data);

    setErrorMessages([]);
    let token: any = localStorage.getItem("credentials");
    const url = `${process.env.REACT_APP_LEMONADE_SERVER}/api/seller-payment-transactions/financial`;
    const postData = {
      sellerMobile: data.sellerMobile,
    };

    let params = new URLSearchParams();
    Object.keys(postData).forEach((key) => {
      params.append(key, postData[key]);
    });

    const paramPostData = params.toString();

    try {
      setNetworkState("PENDING");
      const { data } = await axiosWithAuthInterceptor({
        url: `${url}?sellerMobile=${postData.sellerMobile.toString()}`,
        // url: url,
        // data: paramPostData,
      });

      if (data.err) {
        throw data;
      }
      setNetworkState("SUCCEED");
      setFinancialInfo({ ...data });
    } catch (error) {
      if (error.err) {
        setErrorMessages([...error.err.details.messages]);
      }
      setNetworkState("FAILED");
    }
  };

  return (
    <div style={{ padding: "1rem" }}>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          direction: "rtl",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          {...register("sellerMobile", {
            required: "لطفا شماره موبایل را وارد نمایید"
          })}
          error={!!errors.sellerMobile}
          helperText={errors.sellerMobile ? errors.sellerMobile.message : null}
          fullWidth
          label="شماره موبایل فروشنده"
          variant="outlined"
        />

        <Button
          disabled={!isValid || networkState === "PENDING"}
          fullWidth
          type="submit"
          color="primary"
          variant="contained"
        >
          ثبت
        </Button>

        {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
        {networkState === "FAILED" &&
          (errorMessages.length > 0 ? (
            errorMessages.map((message) =>
              ERROR_MESSAGES_TRANSLATE[message] ? (
                <p>{ERROR_MESSAGES_TRANSLATE[message]}</p>
              ) : (
                <p>خطایی رخ داده لطفا مجددا تلاش نمایید</p>
              )
            )
          ) : (
            <p>خطایی رخ داده لطفا مجددا تلاش نمایید</p>
          ))}
      </form>

      {networkState === "SUCCEED" && (
        <div className="result" style={{ marginTop: "4rem" }}>
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>مجموع فروش تاکنون</TableCell>
                  <TableCell>مجموع واریزی تاکنون</TableCell>
                  <TableCell>مانده بدهی فروشنده</TableCell>
                  <TableCell>تعداد کارت فروخته شده</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <span>
                      {Number(financialInfo.totalSalesAmount)?.toLocaleString(
                        "fa"
                      )}
                    </span>
                    <span>&nbsp;</span>
                    <span>تومان</span>
                  </TableCell>
                  <TableCell>
                    <span>
                      {Number(
                        financialInfo.totalSellerPaymentsAmount
                      )?.toLocaleString("fa")}
                    </span>
                    <span>&nbsp;</span>
                    <span>تومان</span>
                  </TableCell>
                  <TableCell>
                    <span>
                      {" "}
                      {
                        Number(
                          financialInfo.totalSalesAmount -
                            financialInfo.totalSellerPaymentsAmount
                        )
                      ?.toLocaleString("fa")}
                    </span>
                    <span>&nbsp;</span>
                    <span>تومان</span>
                  </TableCell>
                  <TableCell>
                    {Number(financialInfo.salesCount)?.toLocaleString("fa")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        </div>
      )}
    </div>
  );
}
